'use client'

import Link from "next/link"
import { usePathname } from "next/navigation"
import { motion } from "framer-motion"
import { cn } from "@/lib/utils"

const links = [
    { href: "/", label: "Home" },
    { href: "/convocation", label: "Convocation" },
    { href: "/raya", label: "Raya" },
    { href: "/tracking", label: "Tracking" },
]

interface NavLinksProps {
    className?: string;
    onLinkClick?: () => void;
}

export const NavLinks = ({ className, onLinkClick }: NavLinksProps) => {
    const pathname = usePathname()

    return (
        <nav className={cn("flex items-center gap-8", className)}>
            {links.map((link) => {
                const isActive = link.href === "/"
                    ? pathname === link.href
                    : link.href === "/raya"
                        ? pathname === link.href
                        : pathname === link.href || pathname.startsWith(`${link.href}/`)

                return (
                    <Link
                        key={link.href}
                        href={link.href}
                        onClick={onLinkClick}
                        className={cn(
                            "relative text-[10px] uppercase tracking-[0.2em] font-medium transition-colors duration-300 py-2",
                            isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
                        )}
                    >
                        {link.label}
                        {isActive && (
                            <motion.div
                                layoutId="nav-underline"
                                className="absolute -bottom-1 left-0 right-0 h-px bg-primary"
                                transition={{ type: "spring", stiffness: 380, damping: 30 }}
                            />
                        )}
                    </Link>
                )
            })}
        </nav>
    )
}
